import {Fragment, useEffect, useState} from "react";
import {FormControl, FormLabel, Grid, MenuItem, Select, TextField} from "@mui/material";
import {MuiTelInput} from "mui-tel-input";
import {isValidatePhone} from "../../Utils/Helper";

const expectedMovingTimeframe = [
    "Immediately (ASAP)",
    "Within 1 week",
    "Within 2 weeks",
    "Within 1 month",
    "Within 2-3 months",
    "In 3-6 months",
    "In 6+ months",
    "Flexible / Not sure yet"
]

export const WordPressQuoteContact = ({
                                          tab,
                                          cbHandleContact,
                                          validatedResult,
                                          validatedEmail,
                                          lng,
                                          cbHandleMovingDate
                                      }) => {

    const [contact, setContact] = useState({
        email: null,
        phone: null,
    });
    const [expectedMovingDate, setExpectedMovingDate] = useState('Within 2 weeks');


    const handleEmail = event => {
        const {value} = event.target;
        setContact(prevState => ({
            ...prevState,
            email: value
        }))
    }

    const handleMovingDate = event => {
        const {value} = event.target;
        setExpectedMovingDate(value);
        cbHandleMovingDate(value);
    }

    const handleCompanyPhone = value => {
        setContact(prevState => ({
            ...prevState,
            phone: value
        }))
    }

    useEffect(() => {
        cbHandleContact(contact);
    }, [contact])

    console.log('[WordPressQuoteContact] phone valid', isValidatePhone(contact?.phone));

    return (
        <Fragment>
            <Grid size={{xs: 12, md: tab === 'moving' ? 4 : 6}}>
                <FormControl fullWidth>
                    <FormLabel required>
                        {lng === 'cn' ? '预计搬家时间' : "Expected Moving Date"}
                    </FormLabel>
                    <Select
                        sx={{
                            '& .MuiSelect-select': {
                                fontSize: '14px' // Set your desired font size here
                            },
                            '& .MuiOutlinedInput-input': {
                                padding: '5px 14px', // Removes inner padding
                                // height: '33px'
                            },
                        }}
                        value={expectedMovingDate}
                        size='small'
                        onChange={handleMovingDate}
                        MenuProps={{
                            PaperProps: {
                                style: {
                                    maxHeight: 48 * 4.5 + 8,
                                    // width: 250,
                                },
                            },
                        }}
                    >
                        {
                            expectedMovingTimeframe?.map(v => {
                                return <MenuItem value={v}
                                                 sx={{fontSize: '14px'}}>{v}</MenuItem>
                            })
                        }
                    </Select>
                </FormControl>
            </Grid>
            <Grid size={{xs: 12, md: tab === 'moving' ? 4 : 6}}>
                <FormControl fullWidth>
                    <FormLabel required>
                        {lng === 'cn' ? '邮件' : "Email"}
                    </FormLabel>
                    <TextField
                        value={contact?.email}
                        onInput={handleEmail}
                        fullWidth
                        variant='outlined'
                        size='small'
                        sx={{
                            '& .MuiInputBase-root': {  // Targets the root input container
                                height: 33,  // Set custom height (default small is ~36px)
                                fontSize: '14px',  // Consistent font size
                            },
                        }}
                        error={(validatedResult !== null && (!contact?.email || !validatedEmail?.valid)) || (validatedEmail !== null && tab === 'brokerage' && !validatedEmail?.valid)}
                        helperText={validatedResult !== null ?
                            (!contact?.email ? (lng === 'cn' ? "必填" : "Required") :
                                !validatedEmail?.valid && (validatedEmail?.validators?.mx?.reason || validatedEmail?.validators?.regex?.reason || "Invalid")) :
                            (validatedEmail !== null && tab === 'brokerage' && !validatedEmail?.valid) && (validatedEmail?.validators?.mx?.reason || validatedEmail?.validators?.regex?.reason || "Invalid")
                        }
                    />
                </FormControl>
            </Grid>
            <Grid size={{xs: 12, md: tab === 'moving' ? 4 : 6}}>
                <FormControl fullWidth>
                    <FormLabel required={tab?.toLowerCase() === 'moving' ? true : false}>
                        {lng === 'cn' ? '电话' : "Phone"}
                    </FormLabel>
                    <MuiTelInput
                        value={contact?.phone}
                        required
                        fullWidth
                        defaultCountry="CA"
                        onChange={handleCompanyPhone}
                        size="small"
                        sx={{
                            '& .MuiInputBase-root': {  // Targets the root input container
                                height: 33,  // Set custom height (default small is ~36px)
                                fontSize: '14px',  // Consistent font size
                            },
                        }}
                        error={(tab?.toLowerCase() === 'moving') && (validatedResult !== null) && (!isValidatePhone(contact?.phone))}
                        helperText={(tab?.toLowerCase() === 'moving') && (validatedResult !== null) && (!contact?.phone ? 'Required' : !isValidatePhone(contact?.phone) && "Invalid")}
                    />
                </FormControl>
            </Grid>
        </Fragment>
    )
}